import { computed, defineComponent } from '@vue/composition-api';
import AppContainer from './components/app-container/AppContainer.vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { isPartnerAuthenticatedLocally, updateGlobalStorageWithLocal } from '@/api/useAuthStatus';
import { RoutingRouteEnum } from './router/routes.enum';
import { getPartnerInformation } from '@/domains/profile/api/profile';
import ErrorModel from '@/api/models/ErrorModel';
import store from './store';
import { bootIntercom, getIntercomLifecycleVersion } from '@/helpers/intercom';

const { useGetters } = createNamespacedHelpers('authentication');

export default defineComponent({
  components: {
    AppContainer,
  },
  setup(_, ctx) {
    if (isPartnerAuthenticatedLocally()) updateGlobalStorageWithLocal();

    const { isPartnerAuthenticated, role } = useGetters(['isPartnerAuthenticated', 'role']);

    const hideAppContainer = computed(() => {
      return ctx.root.$route.name === RoutingRouteEnum.CLI_Authorized;
    });

    if (isPartnerAuthenticated.value && role.value === null) {
      const partnerID = store.getters['partnerID'];
      const lifecycleVersion = getIntercomLifecycleVersion();
      getPartnerInformation().then((response) => {
        if (
          !(response instanceof ErrorModel) &&
          response.partner &&
          isPartnerAuthenticated.value &&
          role.value === null &&
          store.getters['partnerID'] === partnerID &&
          response.partner.id === partnerID &&
          getIntercomLifecycleVersion() === lifecycleVersion
        )
          bootIntercom(response.partner, isPartnerAuthenticated.value, lifecycleVersion);
      });
    }

    return {
      isPartnerAuthenticated,
      hideAppContainer,
    };
  },
});
